module.exports = __webpack_public_path__ + "static/media/checked.7a7b57f8.png";